var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('div',{staticClass:"app-layout authorized-layout"},[_c('Header'),_c('div',{staticClass:"app-content"},[_vm._t("default"),_c('profile-side-modal')],2),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }